export class Page {
    acf:{
        page_content:any;
        page_css_class:any;
        show_blog_heading:boolean;
    };
    slug:string;
    parent:string;
    author: number;
    title: {
        rendered: string;
    };
    date: string;
    _links: {
        author: { href:string }[];
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/page.ts